import React, { Component } from 'react'
import { inject, observer } from "mobx-react"
import { Tabs, Icon, Alert } from 'antd';
import DiceRoller from '../layoutComponents/DiceRoller';
import CoinFlipper from '../layoutComponents/CoinFlipper';
import DicePageModal from '../modals/DicePageModal';
import { FaDice, FaCoins, FaDiceSix } from 'react-icons/fa';
const TabPane = Tabs.TabPane;
@observer(["eventStore", "UserStore", "AuthStore", "ViewStore", "web3Store", "AdminStore", "TeamStore"])
class Casino extends Component {

    async componentWillMount() {
        this.props.ViewStore.changeView('Casino');
        this.props.ViewStore.changeCurrentPage('Casino');

    }
    componentWillUnmount() {
        this.props.ViewStore.changePreviousPage('Casino')
    }
    render() {
        return (
            <div style={{overflow: "auto"}}>
                {this.props.web3Store.network == 1 ? <DicePageModal /> : ""}
                <Tabs defaultActiveKey="1">
                    <TabPane tab={<span>ROLL A DIE <FaDiceSix /></span>} key="1" >
                        <DiceRoller />
                    </TabPane>
                    {/* <TabPane tab={<span>FLIP A COIN <FaCoins /></span>} key="2" >
                        <CoinFlipper />
                    </TabPane> */}
                </Tabs>
                <br />
                <br />
                <br />
                <p className="space-mono" style={{ fontSize: "7pt" }}>
                    BET AMOUNTS WILL BE KEPT LOW FOR AN INDEFINITE PERIOD AFTER LAUNCH WHILE THE CONTRACT SPINS UP.

                    {this.props.web3Store.network == 1 ? <div>
                        <br />
                        <br />
                        <Alert
                            message="THIS ISN'T THE FULL PLATFORM"
                            description="Switch to the Rinkeby testnet to see what the full mainnet platform will soon look like."
                            type="info"
                            style={{ background: "rgba(255,255,255,0.4)" }}
                            showIcon
                        />
                    </div> : ""}</p>
                <hr />
            </div>
        )
    }
}
export default Casino;



// WEBPACK FOOTER //
// ./src/components/appComponents/Casino.js